module.exports = __webpack_public_path__ + "img/logo.936ce468.png";